module.exports = __webpack_public_path__ + "static/teamwork-258ef2d833269c8476d270c133282fc4.svg";